import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IState, IstateInitialState } from "./stateModel";
import {
  createState,
  deleteState,
  findAllActiveStates,
  getAllStates,
  getStateById,
  stateActiveInactive,
  updateState,
} from "./services/state.services";

const initialState: IstateInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  StateList: [],
  StateID: null,
  StateDetail: {
    state_name: "",
    country_id: "",
    isactive: 1
  },
};

const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {
    clearStateDetails: (state) => {
      state.StateDetail = initialState.StateDetail;
    },
    setStateID: (state, action) => {
      state.StateID = action.payload;
    },
    clearStateID: (state) => {
      state.StateID = initialState.StateID;
    },
  },
  extraReducers: (builder) => {
    /* For getAll States */
    builder.addCase(getAllStates.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllStates.fulfilled,
      (state, action: PayloadAction<IState[]>) => {
        state.loading = false;
        state.StateList = action.payload || [];
      }
    );
    builder.addCase(getAllStates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.StateList = [];
    });

    /* For FindAllActiveStates */
    builder.addCase(findAllActiveStates.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActiveStates.fulfilled,
      (state, action: PayloadAction<IState[]>) => {
        state.loading = false;
        state.StateList = action.payload || [];
      }
    );
    builder.addCase(findAllActiveStates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.StateList = [];
    });

    /* For createStates */
    builder.addCase(createState.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createState.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createState.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For updateStates */
    builder.addCase(updateState.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateState.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateState.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For deleteStates */
    builder.addCase(deleteState.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteState.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteState.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For stateActiveInactive */
    builder.addCase(stateActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(stateActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(stateActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For getStateByID*/

    builder.addCase(getStateById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getStateById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.StateDetail = action.payload;
    });
    builder.addCase(getStateById.rejected, (state, action) => {
      state.formLoading = false;
      state.StateDetail = initialState.StateDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearStateDetails, setStateID, clearStateID } =
  stateSlice.actions;
export default stateSlice.reducer;
